import { createBrowserRouter, Navigate, RouteObject } from 'react-router';
import ProtectedRoute, {
  PublicRoute,
  NotFoundRoute,
} from './components/routing/RouteWrappers';
import LoginPage from './pages/LoginPage';
import NotFoundPage from './pages/NotFoundPage';
import LeadsPage from './pages/LeadsPage';
import OperatorsPage from './pages/OperatorsPage';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to="/leads" replace />,
  },
  {
    path: '/leads',
    element: (
      <ProtectedRoute>
        <LeadsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/operators',
    element: (
      <ProtectedRoute>
        <OperatorsPage />
      </ProtectedRoute>
    ),
  },

  {
    path: '/login',
    element: (
      <PublicRoute>
        <LoginPage />
      </PublicRoute>
    ),
  },
  {
    path: '/dashboard',
    element: <Navigate to="/leads" replace />,
  },

  {
    path: '/404',
    element: (
      <NotFoundRoute>
        <NotFoundPage />
      </NotFoundRoute>
    ),
  },
  {
    path: '*',
    element: <Navigate to="/404" replace />,
  },
];

export const router = createBrowserRouter(routes);
